import React from 'react';
import getFullUserName from 'utils/getFullUserName';
import Flag from 'components/Flag';
import Text from 'components/Text';
import PageTitle from 'components/PageTitle';
import Avatar from 'components/Avatar';
function UserPageHeader(_ref) {
  var email = _ref.email,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    pictureUrl = _ref.pictureUrl;
  var fullName = getFullUserName({
    first_name: firstName,
    last_name: lastName
  });
  var title = fullName || email;
  var subtitle = fullName ? email : null;
  return /*#__PURE__*/React.createElement(Flag, {
    align: "center",
    spacing: "m",
    token: /*#__PURE__*/React.createElement(Avatar, {
      shady: true,
      pictureUrl: pictureUrl,
      size: "big"
    }),
    mb: "m"
  }, /*#__PURE__*/React.createElement(PageTitle, {
    size: "large",
    text: title || ''
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    overflow: "wrap"
  }, subtitle));
}
export default UserPageHeader;